import React from 'react';
import CashBankBook from './CashBank_Book';
import '../../../CommonCSS/SocietyCSS.css'

const CBBookApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Cash/Bank Book Report</h5>
          </div>
        </div>
        <CashBankBook />
      </div>
    </div >
  );
};

export default CBBookApp;
